<template>
  <div>
    <div class="f1" v-if="disabled">{{value}}</div>
    <el-date-picker v-else
      v-model="value"
      type="datetime"
      :placeholder="placeholder"
      :format="format"
      :value-format="valueFormat"
      @change="handleChange">
    </el-date-picker>
  </div>
</template>

<script>
import mixinDate from './mixins/date'
export default {
  mixins: [mixinDate],
  data() {
    const {
      format,
      valueFormat
    } = this.column
    const defFormat = 'yyyy-MM-dd HH:mm:ss'
    return {
      format: format || defFormat,
      valueFormat: valueFormat || defFormat
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./date.scss";
</style>
